var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        [
          _c("h3", { staticClass: "headline mb-0 admin-header" }, [
            _vm._v("Server Logs"),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { text: "", icon: "", color: "grey lighten-1" },
              on: { click: _vm.refresh },
            },
            [_c("v-icon", [_vm._v("fas fa-sync")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          items: _vm.elkLogs,
          loading: _vm.loading,
          headers: _vm.headers,
          "footer-props": { "items-per-page-options": _vm.numRowsPerPage },
          options: _vm.pagination,
          "server-items-length": _vm.totalItems,
        },
        on: {
          "update:options": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.receivedTimestamp",
            fn: function ({ item }) {
              return [
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDateTime(item.receivedTimestamp))),
                ]),
              ]
            },
          },
          {
            key: "item.eventTimestamp",
            fn: function ({ item }) {
              return [
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDateTime(item.eventTimestamp))),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }